module.exports = __webpack_public_path__ + "img/thumb-ryang-off.3d5087b2.jpg";